module.exports = __webpack_public_path__ + "static/tags-based-configuration_5-8395d6109227d9c2ed81d6456dcec70c.png";